/* eslint-disable no-unused-vars */
import { call, put, takeLatest } from "@redux-saga/core/effects";
import * as action from "./desingReducer";
// import { axiosInstance } from "../constant";
// import { getLanguage } from "functions/getLanguage";
// import config from "../../config";
// import { HandleEncryptUser } from "functions/encryption";

// var baseUrlUser = `${config.API_URL}/api/v1/auth`;

// function* UserLogin({ payload }) {
//   try {
//     yield put(action.Loading({ Loading: true }));

//     const response = yield call(
//       axiosInstance.post,
//       baseUrlUser + `/user/signin`,
//       payload
//     );

//     if (response?.data?.token) {
//       yield put(
//         action.Auth({
//           user: response?.data?.user,
//           islogin: true,
//           role: response.data?.user?.roles[0],
//           token: response?.data?.token,
//         })
//       );

//       yield put(
//         action.Message({ message: "Login Success", open: true, error: false })
//       );
//     }
//     yield put(action.Loading({ Loading: false }));
//   } catch (error) {
//     const message = error.response.data.message;
//     yield put(action.Message({ message: message, open: true, error: true }));
//     yield put(action.Loading({ Loading: false }));
//   }
// }

export default function* HomeSaga() {
  //   yield takeLatest("LOGIN_USER", UserLogin);
}